import * as React from "react";
import styled, { css } from "styled-components";

const Item = styled.li`
  flex: 1;
`;

const Link = styled.a<IStyleProps>`
  display: block;
  padding: ${({ theme }) => theme.space[2]};
  background-color: transparent;
  color: black;
  text-align: center;
  text-decoration: none;

  ${(props) =>
    props.selected &&
    css`
      background-color: ${({ theme }) => theme.colors.secondary};
      color: white;
    `}
`;

interface IStyleProps {
  selected: boolean;
}

interface IProps {
  key: number;
  index: number;
  label: React.ReactNode;
  link: string;
  onClick: (index: number) => void;
}

type Props = IStyleProps & IProps;

const Tab: React.FC<Props> = ({ index, label, link, selected, onClick }) => {
  const handleClick = (e: React.SyntheticEvent) => {
    e.preventDefault();
    onClick(index);
  };

  return (
    <Item>
      <Link href={`#${link}`} onClick={handleClick} selected={selected}>
        {label}
      </Link>
    </Item>
  );
};

export default Tab;
